import { PersonFormDto } from '@/modules/people/presentation/person-form.utils';

export function pessoaTemDefensorOuEstagiarioAtivoNoForm(
  values: Pick<PersonFormDto, 'defensor' | 'estagiario' | 'perfisOperacionais'>,
): boolean {
  const defensorAtivo = Boolean(values.defensor) && values.defensor?.ativo !== false;
  const estagiarioAtivo = Boolean(values.estagiario) && values.estagiario?.ativo !== false;
  const perfis = Array.isArray(values.perfisOperacionais) ? values.perfisOperacionais : [];
  const perfilOperacional = perfis.some(
    (p) => (p.kind === 'defensor' || p.kind === 'estagiario') && p.ativo !== false,
  );
  return defensorAtivo || estagiarioAtivo || perfilOperacional;
}

export function loginDefaultsParaFormularioPessoa(
  values: Pick<PersonFormDto, 'defensor' | 'estagiario' | 'perfisOperacionais'>,
): { loginSenhaHabilitado: boolean; loginTokenHabilitado: boolean } {
  if (pessoaTemDefensorOuEstagiarioAtivoNoForm(values)) {
    return { loginSenhaHabilitado: false, loginTokenHabilitado: true };
  }
  return { loginSenhaHabilitado: true, loginTokenHabilitado: true };
}
